import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'

import { allUser, disableUsers, modifyUserInfo ,contactInfoFengLou,guaranteeUsers} from '../../api'





export default /*#__PURE__*/_defineComponent({
  __name: 'userList',
  setup(__props) {

const search = reactive({
  key: "",
  state: "0", 
})


const loading = ref(false);

const selectedKeys = ref([]);

const dataSource = ref([]);

const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
  { title: "用户ID", width: "260px", key: "userId", align: "center" },
  { title: "账号", key: "userName", align: "center" },
  { title: "邮箱", key: "email", align: "center" },
  { title: "状态", key: "state", align: "center", customSlot: "state" },
  { title: "担保", key: "guarantee", align: "center", customSlot: "guarantee" }, 
  { title: "积分", key: "member", align: "center", customSlot: "member" },
  { title: "到期时间", key: "endTime", align: "center" },
  { title: "备注", key: "notes", align: "center" },
  { title: "注册时间", key: "addTime", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center", width: "200px" }
]);


const getAllUser = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit, "key": search.key, "state": search.state, "type": search.type };
  allUser(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}

getAllUser();

const change = (page: any) => {
  getAllUser();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}


//禁用或者开启
const changedelFlag = (row: any) => {

  var data = { "key": row.userId, "id": row.delFlag };
  disableUsers(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllUser();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}


const changeGuarantee = (row: any) => { 
  var data = { "key": row.userId, "id": row.guarantee };
  guaranteeUsers(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllUser();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}






//搜索
const searchUser=()=>{
  page.current=1;

  getAllUser();
}




const user = reactive({
  userId: "",
  userName: "",
  password: "", 
  endTime: "",
  notes: ""
})


const fengLouInfo = reactive({
  userId: "",
  phone: "",
  qq: "", 
  weChat: "",
  plain: ""
})






const  updateUser = (row: any) => {
  user.userId = row.userId;
  user.userName = row.userName; 
  user.endTime = row.endTime;
  user.notes = row.notes==null?"":row.notes;
  user.password = "";
  isDisabled.value = true;
  visible11.value = !visible11.value;
}


const updatefeng = (row: any) => {
  fengLouInfo.userId = row.userId; 
  isfeng.value = !isfeng.value;
}





const layFormRef11 = ref();

const visible11 = ref(false);
const isfeng = ref(false);



const isDisabled = ref(false);

const action11 = ref([
  {
    text: "确认",
    callback: () => {
 

      modifyUserInfo(JSON.stringify(user)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllUser();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visible11.value = false;
    }
  }
])



const fengbtu = ref([
  {
    text: "确认",
    callback: () => {
 

      contactInfoFengLou(JSON.stringify(fengLouInfo)).then((res: any) => {
        if (res != "" && res.code == 0) {
      
          isfeng.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      isfeng.value = false;
    }
  }
])





return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_date_picker = _resolveComponent("lay-date-picker")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "账号",
                      prop: "key",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入账号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "状态",
                      prop: "state",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.state,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.state) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "正常"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "禁用"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 0 ? true : false,
                      onChange: ($event: any) => (changedelFlag(row)),
                      "onswitch-text": "正常",
                      "unswitch-text": "禁用"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  guarantee: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.guarantee == 2 ? true : false,
                      onChange: ($event: any) => (changeGuarantee(row)),
                      "onswitch-text": "担保",
                      "unswitch-text": "不担保"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateUser(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updatefeng(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("批量楼凤修改")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['350px', '550px'],
      btn: action11.value,
      title: "修改用户信息"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_lay_form, {
            model: user,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "账户",
                prop: "userName",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: user.userName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.userName) = $event)),
                    disabled: isDisabled.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: user.password,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.password) = $event)),
                    type: "text",
                    placeholder: "无需修改请置空"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "到期时间",
                prop: "endTime",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_date_picker, {
                    type: "datetime",
                    modelValue: user.endTime,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.endTime) = $event)),
                    placeholder: "请选择会员到期时间"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "notes",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: user.notes,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.notes) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: isfeng.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isfeng).value = $event)),
      shade: false,
      area: ['350px', '400px'],
      btn: fengbtu.value,
      title: "批量修改楼凤信息"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: fengLouInfo,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "手机号",
                prop: "phone",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: fengLouInfo.phone,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((fengLouInfo.phone) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "qq",
                prop: "qq",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: fengLouInfo.qq,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((fengLouInfo.qq) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "微信",
                prop: "weChat",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: fengLouInfo.weChat,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((fengLouInfo.weChat) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "飞机",
                prop: "plain",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: fengLouInfo.plain,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((fengLouInfo.plain) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})